import styles from "./styles.module.css";
import { useDrag } from "react-dnd";
import { getEmptyImage } from "react-dnd-html5-backend";
import { useEffect } from "react";

const defaultProps = (props) => {
  const _props = {};
  props.map((x) => {
    _props[x.name] = x.editorParams.default;
  });
  return _props;
};

export default function Card({ block, type }) {
  const [{ isDragging }, dragRef, preview] = useDrag({
    item: {
      type: type ? type : "component",
      block: {
        component: block.name,
        name: "new " + block.displayName,
        props: defaultProps(block.props),
        params: block.props.map((x) => ({
          name: x.name,
          displayName: x.displayName,
          format: x.format || null,
        })),
        children: [],
        dynamic: block.dynamic ? block.dynamic : null,
        sources: block.sources ? block.sources.map((s) => s.name) : null,
        stateVariables: block.stateVariables ? block.stateVariables : null,
        actions: block.actions ? block.actions : null,
      },
      kind: block.type,
      new: true,
    },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  });

  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true });
  }, []);
  return (
    <div
      style={{ borderColor: isDragging ? "var(--main)" : null }}
      ref={dragRef}
      className={styles.card}
      style={{
        backgroundImage: `url(${block.image})`,
      }}
    >
      {/* <div
        style={{
          backgroundImage: `url(${block.image})`,
        }}
        className={styles.cardImage}
      ></div> */}
      <div className={styles.cardText}>{block.displayName}</div>
    </div>
  );
}
